export const campaign = {
  createDripCampaign: "Create Drip Campaign",
  importCSV: "Import CSV as Drip Campaign",
  campaignName: "Campaign: {{name}}",
  addNewsletter: "Add Newsletter to Campaign: {{name}}",
  success: {
    created: "Campaign created successfully",
    imported: "Campaign created with {{count}} emails imported successfully",
    enrolled: "Started enrolling eligible subscribers",
    newsletterAdded: "Newsletter added to campaign successfully",
    emailDeleted: "Email deleted from campaign",
    sequenceReversed: "Email sequence reversed successfully",
    statusUpdated: "Campaign status updated to {{status}}",
    deleted: "Campaign deleted successfully",
    templatesUpdated: "Workshop templates updated successfully",
    testSequence: "{{message}}",
    workshopSequenceToggled: "{{message}}",
    workshopSequencesInitialized: "{{message}}",
  },
  errors: {
    createFailed: "Failed to create campaign",
    importFailed: "Failed to import campaign",
    enrollFailed: "Failed to enroll subscribers",
    addNewsletterFailed: "Failed to add newsletter to campaign",
    deleteEmailFailed: "Failed to delete email",
    reverseSequenceFailed: "Failed to reverse sequence",
    updateStatusFailed: "Failed to update campaign status",
    deleteCampaignFailed: "Failed to delete campaign",
    testSequenceFailed: "Test sequence failed: {{error}}",
    testSequenceError: "Test sequence error: {{error}}",
    retryInitiated: "Retry initiated for failed emails",
  },
}
